import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ChatMessage} from "../../../services/api.service";
import {DatePipe, JsonPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {RequireClaimsDirective} from "../../../auth/components/require-claims.directive";
import {TextFieldModule} from "@angular/cdk/text-field";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'chat-message-node',
  standalone: true,
  imports: [
    NgIf,
    DatePipe,
    MatFormFieldModule,
    MatInputModule,
    NgForOf,
    RequireClaimsDirective,
    TextFieldModule,
    NgClass,
    RouterLink,
    JsonPipe
  ],
  templateUrl: './chat-message-node.component.html',
  styleUrl: './chat-message-node.component.sass'
})
export class ChatMessageNodeComponent implements OnChanges {
  @Input() message?: ChatMessage
  @Input() sub?: string

  textLines: string[] = []

  ngOnChanges(changes: SimpleChanges): void {
    this.textLines = (this.message?.message || '').split('\n')
  }
}
